import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { IOptionsApprovalResponseModel } from '../interfaces/options-approval-response.model';
import { environment } from '../../../../environments/environment';
import { IOptionsApprovalRequestModel } from '../interfaces/options-approval-request.model';

@Injectable({
    providedIn: 'root'
})
export class OptionsApprovalService {
    public readonly apiUrl: string = environment.apiUrl;
    public readonly baseUrl: string = '/api/OptionsApproval';

    public constructor(
        private readonly _http: HttpClient
    ) {}

    public async getOptionsApproval(
        timeValue: string,
        subDepartmentId: string
    ): Promise<IOptionsApprovalResponseModel> {
        const url: string = `${this.apiUrl + this.baseUrl}/${timeValue}/${subDepartmentId}`;
        const response$: Observable<IOptionsApprovalResponseModel> = this._http.get<IOptionsApprovalResponseModel>(url);
        return firstValueFrom(response$);
    }

    public async saveOptionsApproval(model: IOptionsApprovalRequestModel): Promise<IOptionsApprovalResponseModel> {
        const url: string = this.apiUrl + this.baseUrl;
        const response$: Observable<IOptionsApprovalResponseModel> = this._http.post<IOptionsApprovalResponseModel>(url, model);
        return firstValueFrom(response$);
    }

    public async approveOptionsApproval(optionsApprovalId: number): Promise<IOptionsApprovalResponseModel> {
        const url: string = `${this.apiUrl + this.baseUrl}/approve/${optionsApprovalId}`;
        const response$: Observable<IOptionsApprovalResponseModel> = this._http.post<IOptionsApprovalResponseModel>(url, null);
        return firstValueFrom(response$);
    }

    public getShortId(id: string): string {
        return id.split('-').pop() || '';
    }
}
